exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-chasing-dots {\r\n    top: 50%;\r\n    margin: auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n    text-align: center;\r\n    animation: sk-chasingDotsRotate 2s infinite linear;\r\n}\r\n\r\n.sk-chasing-dots .sk-child {\r\n    width: 60%;\r\n    height: 60%;\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: 0;\r\n    border-radius: 100%;\r\n    animation: sk-chasingDotsBounce 2s infinite ease-in-out;\r\n}\r\n\r\n.sk-chasing-dots .sk-dot2 {\r\n    top: auto;\r\n    bottom: 0;\r\n    animation-delay: -1s;\r\n}\r\n\r\n@keyframes sk-chasingDotsRotate {\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes sk-chasingDotsBounce {\r\n    0%, 100% {\r\n        transform: scale(0);\r\n    }\r\n    50% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/spinner/spinkit-css/sk-chasing-dots.css
// module id = ../../../../../src/app/shared/spinner/spinkit-css/sk-chasing-dots.css
// module chunks = main